import { Form } from 'react-final-form';

import { useTranslation } from 'react-i18next';

import ModalFormPage from '../../../../../../../styledComponents/ModalFormPage/ModalFormPage';
import WarningsConfirmationModal from '../../../../../../../styledComponents/WarningsConfirmation/WarningsConfirmationModal/WarningsConfirmationModal';

import { withErrorProvider } from '../../../../../../../hoc/withErrorProvider';
import { withWarningsConfirmationProvider } from '../../../../../../../hoc/withWarningsConfirmationProvider';
import { SmallModal } from '../../../../../../../styledComponents/ModalCommon/ModalCommon';
import { useSRSubscriptionEditDetailsModal } from './srSubscriptionEditOptionsModal.hooks';
import { EDITING_SR_SUBSCRIPTION_OPTIONS_MODAL_NAME } from './srSubscriptionEditOptionsModal.const';
import { StyledSubscriptionOptions } from './srSubscriptionEditOptionsModal.styles';

interface ISRSubscriptionEditDetailsModalProps {
  onModalSuccess: () => void;
}

const SRSubscriptionEditOptionsModal = ({
  onModalSuccess,
}: ISRSubscriptionEditDetailsModalProps) => {
  const { t } = useTranslation();

  const {
    handleWarningsConfirm,
    handleSubmit,
    subscriptionEditing,
    initData,
    onCancelHandler,
  } = useSRSubscriptionEditDetailsModal({ onModalSuccess });

  return (
    <>
      <WarningsConfirmationModal onWarningsConfirm={handleWarningsConfirm} />
      <SmallModal name={EDITING_SR_SUBSCRIPTION_OPTIONS_MODAL_NAME}>
        <Form
          initialValues={initData}
          keepDirtyOnReinitialize
          onSubmit={handleSubmit}
        >
          {({ ...renderProps }) => (
            <ModalFormPage
              handleSubmit={renderProps.handleSubmit}
              isProcessing={subscriptionEditing}
              onCancel={onCancelHandler}
              mode="small"
              title={t('headers.edit-options')}
            >
              <StyledSubscriptionOptions
                layout="column"
                disabled={subscriptionEditing}
              />
            </ModalFormPage>
          )}
        </Form>
      </SmallModal>
    </>
  );
};

export default withErrorProvider(
  withWarningsConfirmationProvider(SRSubscriptionEditOptionsModal),
);
